import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="vocalize-header">
      <div className="vocalize-brand">Vocalize</div>
      <button className="vocalize-add-btn">Add Books</button>
    </header>
  );
};

export default Header;
